import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { selectAllCatalogItems, getCatalog, catalogTotalCount, searchCatalog } from '../../reducers/catalog';
import Product from "./Product";
import { useParams, useSearchParams } from "react-router-dom";
import ProductMenu from '../ProductMenu';
import { selectAllMenuItems } from '../../reducers/menu';
import MSMPagination from '../MSMPagination';
import { Container, Row } from "react-bootstrap";
import { getSubsite } from '../../reducers/auth';

const AdminCatalog = () => {
  let { categoryId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();
  const catalog = useSelector(selectAllCatalogItems);
  const menu = useSelector(selectAllMenuItems);
  const featured = useSelector(state => state.featured);

  const [resetPagination, setResetPagination] = useState(false);
  const [range, setRange] = useState([1, 12]);

  const catalogStatus = useSelector(state => state.catalog.status)
  const catalogTotal = useSelector(catalogTotalCount);
  const currentSubsite = useSelector(getSubsite);

  useEffect(() => {
    if (catalogStatus === 'idle') {
      if (categoryId === 0) {
        categoryId = menu.menu[0].id; 
      }
      dispatch(getCatalog([categoryId, range[0], range[1]]));
    }
  }, [catalogStatus, dispatch]);

  useEffect(() => {
    dispatch(getCatalog([categoryId, range[0], range[1]]));
  }, [categoryId, dispatch]);

  useEffect(() => {
    if (searchParams.get("searchTerm")) {
      dispatch(searchCatalog([searchParams.get("searchTerm"), range[0], range[1]]));
    } else {
      dispatch(getCatalog([categoryId, range[0], range[1]]));
    }
  }, [range, dispatch]);

  const reloadData = (range) => {
    setRange(range);
  }

  return (
    <div className="container">
      <ProductMenu url="/admin/catalog/" menuBgColor={currentSubsite.subsite_content?.menuBgColor} menuTextHoverColor={currentSubsite.subsite_content?.menuTextHoverColor} menuTextColor={currentSubsite.subsite_content?.menuTextColor}/>
      <MSMPagination reload={reloadData} perPage={range[1]} total={catalogTotal} reset={resetPagination} />
      {catalogStatus === 'loading' && <Spinner text="Loading..." />}
      {catalogStatus === 'error' && <div>Error Loading Products</div>}
      <Container>
        <Row>
          {catalog && catalog.catalog && catalog.catalog.map(catalogItem => (
            <Product product={catalogItem} />
          ))}
        </Row>
      </Container>
    </div>
  );
};
export default AdminCatalog;